import { primeDimensionTypes } from "./src/utils/misc";
export { default as ContextSelectorV2 } from "./src/components/ContextSelectorV2";
export { default as PlotConfigSelect } from "./src/components/PlotConfigSelect";
export { default as renderConditionally } from "./src/utils/render-conditionally";
export { default as DimensionSelectV2 } from "./src/components/DimensionSelectV2";
export { default as ContextBuilderV2 } from "./src/components/ContextBuilderV2";
export { default as ContextManager } from "./src/components/ContextManager";
export { default as DataExplorerPage } from "./src/components/DataExplorerPage/components/DataExplorer2";
export { default as ContextTypeSelect } from "./src/components/ContextManager/ContextTypeSelect";

export {
  DataExplorerSettingsProvider,
  useDataExplorerSettings,
  useLaunchSettingsModal,
} from "./src/contexts/DataExplorerSettingsContext";

export {
  PlotlyLoaderProvider,
  usePlotlyLoader,
} from "./src/contexts/PlotlyLoaderContext";

// Shared by every slice table that lets someone curate its metadata columns, so
// that reopening one doesn't mean re-picking them. See the module for why the
// scope is part of the key.
export {
  forgetRememberedColumns,
  loadRememberedColumns,
  rememberColumns,
} from "./src/utils/rememberedTableColumns";
export type { RememberedColumnsScope } from "./src/utils/rememberedTableColumns";

export {
  contextsMatch,
  initializeDevContexts,
  isNegatedContext,
  isV2Context,
  negateContext,
  saveContextToLocalStorageAndPersist,
} from "./src/utils/context";

export { isContextAll } from "./src/utils/contextExpr";

export { convertContextV1toV2 } from "./src/utils/context-converter";

export { fetchContext, persistContext } from "./src/utils/context-storage";

export {
  capitalize,
  convertDimensionToSliceId,
  convertDimensionToSliceQuery,
  getDimensionTypeLabel,
  isPartialSliceId,
  isSampleTypeSync,
  sortDimensionTypes,
  uncapitalize,
  urlLibEncode,
} from "./src/utils/misc";

export {
  isCompleteDimension,
  isCompleteExpression,
  isSampleType,
  pluralize,
} from "./src/utils/dimensionHelpers";

export { persistLegacyListAsContext } from "./src/utils/persistLegacyListAsContext";

export { default as DensityPlot } from "./src/components/DataExplorerPage/components/plot/prototype/PrototypeDensity1D";

export {
  logInitialPlot,
  logReducerTransform,
} from "./src/components/DataExplorerPage/debug";
export { PointsSelector } from "./src/components/DataExplorerPage/components/ConfigurationPanel/selectors";
export { default as plotConfigReducer } from "./src/components/DataExplorerPage/reducers/plotConfigReducer";
export type { PlotConfigReducerAction } from "./src/components/DataExplorerPage/reducers/plotConfigReducer";
export {
  DEFAULT_PALETTE,
  LEGEND_ALL,
  LEGEND_BOTH,
  LEGEND_OTHER,
  LEGEND_RANGE_1,
  LEGEND_RANGE_2,
  LEGEND_RANGE_3,
  LEGEND_RANGE_4,
  LEGEND_RANGE_5,
  LEGEND_RANGE_6,
  LEGEND_RANGE_7,
  LEGEND_RANGE_8,
  LEGEND_RANGE_9,
  LEGEND_RANGE_10,
} from "./src/components/DataExplorerPage/components/plot/prototype/plotUtils";
export type { LegendKey } from "./src/components/DataExplorerPage/components/plot/prototype/plotUtils";

// Web apps only: see primeDimensionTypes.
primeDimensionTypes();
